const commentBasePath = '/all-comments';


const CommentConst = {
  basePath     : commentBasePath
};

export default CommentConst;